export const groupsConstants = {
  GROUPS_DATA: "GROUPS_DATA",
  GROUPS_DATA_UPDATE: "GROUPS_DATA_UPDATE",
  GROUPS_ROLE_DATA: "GROUPS_ROLE_DATA",
  STORES_BY_GROUP_ID: "STORES_BY_GROUP_ID",
  GROUP_CREATED: "GROUP_CREATED",
  GROUPS: "GROUPS",
  RESET_GROUPS: "RESET_GROUPS",
  GROUP_DETAIL: "GROUP_DETAIL",
  PAGINATED_GROUPS_DATA: "PAGINATED_GROUPS_DATA",
  GET_ALL_LOCATIONS: "GET_ALL_LOCATIONS",
  AND: " AND ",
  OR: " OR ",
  STATE: "state",
  NAME: "name",
  OWNER_NAME: "ownerName",
  UPDATE_GROUP: "UPDATE_GROUP",
  UPDATE_GROUP_RESPONSE: "UPDATE_GROUP_RESPONSE",
  GROUP_USER_ADD_ERROR:
    "Please create a user for this group first to activate the group!",
  CREATE_SYSTEM_USER: "_createSystemUser",
  RESET_GROUPS_AGAINST_BRAND_ID: "RESET_GROUPS_AGAINST_BRAND_ID",
};

export const inputFieldNames = {
  NAME: "name",
  BRAND_LOCATIONS: "stores",
  BRAND_LOCATIONS_MANAGER: "brandLocationsIds",
  BRAND_LOCATIONS_IDS: "storeIds",
};

export const tabsNames = {
  group: "group",
  managers: "managers",
};
